export class GetLastRecordFromManagementByIdSectorUseCase{
  constructor(repository){
    this.repository=repository
  }

  async execute(ID_SECTOR){
    return await this.repository.getLastRegisterFromManagementByIdSector(ID_SECTOR)
  }
}
